import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_159: DocMigration = {
  maxSchemaVersion: "0.0.159",
  description: "Eave returns parameter refactoring",
  apply(json: any) {
    const { settings: allSettings, roofs } = json;

    const migrateEaveReturnRoofMaterial = (roofSettings: any, isInstance: boolean) => {
      let eaveReturnRoofMaterial = undefined;

      if (isInstance) {
        const { rafterTailMaterial, miniHipMaterial, miniShedMaterial } = roofSettings;

        switch (roofSettings.eaveType) {
          case "BOXED_FULL_RETURN":
            eaveReturnRoofMaterial = rafterTailMaterial;
            break;
          case "BOXED_MINI_HIP":
            eaveReturnRoofMaterial = miniHipMaterial;
            break;
          case "BOXED_MINI_SHED":
            eaveReturnRoofMaterial = miniShedMaterial;
            break;
          default:
            eaveReturnRoofMaterial = rafterTailMaterial ?? miniHipMaterial ?? miniShedMaterial;
            break;
        }

        roofSettings.eaveReturnRoofMaterial = eaveReturnRoofMaterial;
      }

      delete roofSettings.rafterTailMaterial;
      delete roofSettings.miniHipMaterial;
      delete roofSettings.miniShedMaterial;

      if (roofSettings.rafterTailSlope !== undefined) {
        roofSettings.eaveReturnRoofSlope = roofSettings.rafterTailSlope;
        delete roofSettings.rafterTailSlope;
      }
    };

    // roof settings
    for (const settingsId in allSettings) {
      const settings = allSettings[settingsId];
      if (settings.type !== "ROOF_SETTINGS") {
        continue;
      }

      migrateEaveReturnRoofMaterial(settings, false);
    }

    // roof instances
    for (const roofId in roofs) {
      const { roofSettings = {} } = roofs[roofId];

      migrateEaveReturnRoofMaterial(roofSettings, true);
    }

    return json;
  },
};

export default migration_0_0_159;
